import React from "react";
import { useFela } from "react-fela";
import { IWithCustomStyle } from "../../hooks/useTheme/types";
import { useTheme } from "../../hooks/useTheme";

type IProps = IWithCustomStyle & JSX.IntrinsicElements["textarea"];

export const Textarea = React.forwardRef<HTMLTextAreaElement, IProps>(
  ({ customStyle = {}, ...rest }, ref) => {
    const { css } = useFela();
    const { colors } = useTheme();

    return (
      <textarea
        ref={ref}
        className={css(
          {
            width: "100%",
            padding: "6px 14px",
            color: colors.DARK_GREY,
            fontSize: 14,
            borderRadius: 4,
            lineHeight: 2,
            border: "solid 1px #BEC1D0",
            nested: {
              ":focus": {
                outline: 0,
              },
            },
          },
          customStyle,
        )}
        {...rest}
      />
    );
  },
);
